import { useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { StateStatus } from '@guryou/redux';

import { getPublicSessions } from '../new/session';

const usePublicSessions = classId => {
  const dispatch = useDispatch();
  const { data, status, version, entity, request } = useSelector(state => state.sessions.active);
  const lastRequestedClassId = useRef(null);

  useEffect(() => {
    if (!classId) {
      return;
    }
    const requestedClassId = Number(classId);
    const loadedForClass = status === StateStatus.LOADED && Number(request?.classId) === requestedClassId;
    if (
      status === StateStatus.NOT_INITIALIZED ||
      (status === StateStatus.LOADED && !loadedForClass) ||
      (status === StateStatus.ERROR && lastRequestedClassId.current !== requestedClassId)
    ) {
      lastRequestedClassId.current = requestedClassId;
      dispatch(getPublicSessions(classId));
    }
  }, [classId, data, dispatch, request, status]);

  if (!classId) {
    return { data: null, status: StateStatus.NOT_INITIALIZED };
  }
  return { data: data || [], status, version, entity };
};

export default usePublicSessions;
